import { getPageUID, getValueByType, getSurveyEmailValueByType } from '../../lib/getValueByType'
import * as actionTypes from './actionTypes'
import { fromJS, Map, List, isImmutable } from 'immutable'
import { getAxios } from '../../lib/projectAxios'
import uuid from 'uuid/v4'
import { parseURLParameters } from '../../lib/common'
import { isElementsValid } from '../../lib/processPortalRules'
const axios = getAxios()

export const processSurveyStart = () => async (dispatch, getState) => {
  const recursiveProcessFinish = async (attemp) => {
    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    try {
      let result = await axios.post('/webprojects/survey/start', {}, {})
      return result
    } catch (err) {
      console.log('err >>> ', err)
      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessFinish(attemp + 1)
    }
  }

  const { status, data } = await recursiveProcessFinish(0)

  return {
    status: true,
  }
}
export const processSurveyFinish =
  (flowSlides, isPartial, slide, isLast = true, runInBackground, isOnload) =>
  async (dispatch, getState) => {
    if (isPartial && slide && slide.isStart) {
      return {
        status: true,
      }
    }
    if (isLast) {
      runInBackground = false
    }
    let state = getState()
    let projectType = state.getIn(['project', 'ProjectType'])
    const childSlides = _.get(slide, ['children'], [])
    let page,
      pageUID,
      elements = Map()
    let pageID = state.get('page')
    pageUID = getPageUID(pageID, state.getIn(['project', 'Pages'], List()))
    if (projectType != 'surveyEmail') {
      let { isValid, retState: rs } = isElementsValid(childSlides, state, false, null, null, pageUID)
      if (!isValid) {
        return {
          status: true,
        }
      }
    }

    if (!window.endProcessTime) {
      window.endProcessTime = new Date().getTime()
    }
    let fillTime = window.endProcessTime - window.startProcessTime
    if (!isNaN(fillTime)) {
      fillTime = fillTime / 1000
      if (state.getIn(['project', 'Settings', 'limits', 'fillLimitTime'])) {
        let limitTime = state.getIn(['project', 'Settings', 'limits', 'fillLimitTime'])
        if (limitTime < fillTime) {
          dispatch({
            type: actionTypes.NOTIFY_ERROR,
            payload: {
              key: uuid(),
              message: state.getIn(
                ['project', 'Settings', 'survey', 'captions', 'Fill Limit'],
                `Time for fill form - expired`
              ),
            },
          })
          return {
            status: false,
          }
        }
      }
    }

    let hashValues = {}

    if (pageUID) {
      page = state.getIn(['pages', pageID])
      if (!page) {
        return {
          status: false,
        }
      }
      elements = page.getIn(['Props', 'elements'])
      pageUID = getPageUID(pageID, state.getIn(['project', 'Pages'], List()))
    }

    if (projectType == 'surveyEmail' && !slide) {
      state.getIn(['project', 'Settings', 'elements'], Map()).map((elem, elemId) => {
        elem = elem.set('isProjectElem', true)
        elements = elements.set(elemId, elem)
      })
    }

    if (!elements) {
      return {
        status: false,
      }
    }
    let filledElements = []
    if (flowSlides) {
      _.each(flowSlides, function (slide) {
        filledElements = filledElements.concat(slide.children)
      })
    }
    let urlParams = parseURLParameters()
    elements.map((elem, elemUID) => {
      let isProcessElement = true
      if (isOnload && projectType === 'surveyEmail') {
        isProcessElement = false
      } else if (isPartial) {
        if (slide && slide.children) {
          if (slide.children.indexOf(elemUID) === -1) {
            isProcessElement = false
          }
        }
      } else {
        if (flowSlides) {
          if (filledElements.indexOf(elemUID) === -1) {
            isProcessElement = false
          }
        }
      }

      if (isProcessElement || elem.get('isProjectElem')) {
        let val
        if (elem.get('isProjectElem')) {
          val = getSurveyEmailValueByType(elem, urlParams)
        } else {
          val = getValueByType(elem, pageUID, elemUID, state)
        }
        if (val !== undefined) {
          hashValues[elemUID] = {
            value: val,
          }
        }
      }
    })

    let form = new FormData()
    form.append('data', JSON.stringify(hashValues))
    form.append('isLast', isLast)
    if (slide && projectType == 'surveyEmail') {
      form.append('isLastEmail', true)
    }

    elements.map((elem, elemUID) => {
      if (elem.get('type') == 'FormField' && elem.getIn(['props', 'control']) == 'fileupload') {
        try {
          if (window.__FT_PROJECT__API__ && typeof window.__FT_PROJECT__API__.getFilesByID == 'function') {
            let files = window.__FT_PROJECT__API__.getFilesByID(elemUID)
            _.each(files, function (file, index) {
              form.append(elemUID + '___' + index, file)
            })
          }
        } catch (err) {
          console.error(err)
        }
      }
    })

    const recursiveProcessFinish = async (attemp) => {
      if (attemp >= 3) {
        return {
          status: 200,
          data: {
            status: false,
          },
        }
      }
      try {
        let result = await axios.post('/webprojects/survey/finish', form, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        return result
      } catch (err) {
        console.log('err >>> ', err)
        dispatch({
          type: actionTypes.NOTIFY_ERROR,
          payload: {
            key: uuid(),
            message: `You are offline, trying again in 2 seconds...`,
          },
        })
        await new Promise((resolve) => {
          setTimeout(resolve, 2 * 1000)
        })

        return recursiveProcessFinish(attemp + 1)
      }
    }
    if (!runInBackground) {
      dispatch({
        type: actionTypes.SHOW_LOADING_WINDOW,
        payload: {
          messages: ['Sending...'],
        },
      })
    }

    const processFinish = async () => {
      const { status, data } = await recursiveProcessFinish(0)
      if (!runInBackground) {
        dispatch({
          type: actionTypes.CLOSE_LOADING_WINDOW,
        })
      }
      if (data.status) {
        return {
          status: true,
        }
      } else {
        if (data.error == 'limit_submit') {
          dispatch({
            type: actionTypes.FETCH_DATA_ERROR,
            payload: {
              error: state.getIn(
                ['project', 'Settings', 'survey', 'captions', 'Submit Limit Error Message'],
                `This survey was already completed.`
              ),
            },
          })
        } else {
          dispatch({
            type: actionTypes.FETCH_DATA_ERROR,
            payload: {
              error: data.error || 'An error occurred, try again later',
            },
          })
        }
        return {
          status: false,
        }
      }
    }

    if (runInBackground) {
      processFinish()

      return {
        status: true,
      }
    } else {
      return processFinish()
    }
  }
